import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { ButtonComponent } from '../../shared/components/redesign/botao/botao.component';
import { CampoTelefoneComponent } from '../../shared/components/redesign/campo-telefone/campo-telefone.component';
import { TelefoneInternacional } from '../../shared/components/redesign/campo-telefone/models/telefone-internacional.model';
import {
  DDI_BRASIL, MAX_DIGITOS_TELEFONE, MAX_DIGITOS_TELEFONE_BRASIL, MIN_DIGITOS_TELEFONE_BRASIL, MIN_DIGITOS_TELEFONE_INTERNACIONAL
} from '../../shared/components/redesign/campo-telefone/utils/campo-telefone.constantes';
import { CampoTextoComponent } from '../../shared/components/redesign/campo-texto/campo-texto.component';
import { ContatoCadastro } from '../../shared/model/contato/contato-cadastro.model';
import { ContatoService } from '../../shared/service/contato.service';
import { MsgService } from '../../shared/service/msg.service';
import { MethodsUtils } from '../../shared/util/methods.utils';
import { TAMANHO_MINIMO_NOME_CONTATO } from './utils/modal-cadastro-contato.constantes';
import { ContatoCriado } from './models/contato-criado.model';
import { ArrastarFecharSheetDirective } from '../../chat/utils/arrastar-fechar-sheet.directive';

@Component({
  selector: 'app-modal-cadastro-contato',
  standalone: true,
  imports: [FormsModule, MatIconModule, ButtonComponent, CampoTextoComponent, CampoTelefoneComponent, ArrastarFecharSheetDirective],
  templateUrl: './modal-cadastro-contato.component.html',
  styleUrls: [
    '../../shared/components/redesign/modal-editar-contato/modal-editar-contato.component.css',
    './modal-cadastro-contato.component.css'
  ]
})
export class ModalCadastroContatoComponent {
  private readonly dialogRef = inject<MatDialogRef<ModalCadastroContatoComponent, ContatoCriado>>(MatDialogRef);
  private readonly contatoService = inject(ContatoService);
  private readonly msgService = inject(MsgService);

  nome = '';
  telefone: TelefoneInternacional = { ddi: DDI_BRASIL, numero: '' };
  email = '';

  erroNome = '';
  erroTelefone = '';
  erroEmail = '';
  salvando = signal(false);

  cancelar(): void {
    this.dialogRef.close();
  }

  salvar(): void {
    if (this.salvando() || !this.validar()) return;

    const email = this.email.trim();
    const contato = new ContatoCadastro(this.nome.trim(), `${this.telefone.ddi}${this.telefone.numero}`, email);
    this.salvando.set(true);
    this.contatoService.salvarContato(contato).subscribe({
      next: id => {
        this.msgService.msgSucesso('Contato cadastrado com sucesso.');
        this.dialogRef.close({ id, nome: contato.nome ?? '', numero: contato.numero ?? '' });
      },
      error: () => this.salvando.set(false)
    });
  }

  private validar(): boolean {
    this.erroNome = this.nome.trim().length < TAMANHO_MINIMO_NOME_CONTATO
      ? `Informe o nome do contato (mínimo ${TAMANHO_MINIMO_NOME_CONTATO} letras).`
      : '';
    this.erroTelefone = this.telefoneValido() ? '' : 'Informe um número válido.';
    const email = this.email.trim();
    this.erroEmail = email && !MethodsUtils.validarEmail(email) ? 'Informe um e-mail válido.' : '';
    return !this.erroNome && !this.erroTelefone && !this.erroEmail;
  }

  private telefoneValido(): boolean {
    const digitos = this.telefone.numero.length;
    if (this.telefone.ddi === DDI_BRASIL) {
      return digitos >= MIN_DIGITOS_TELEFONE_BRASIL && digitos <= MAX_DIGITOS_TELEFONE_BRASIL;
    }
    return digitos >= MIN_DIGITOS_TELEFONE_INTERNACIONAL && digitos + this.telefone.ddi.length <= MAX_DIGITOS_TELEFONE;
  }
}
